import { Checkbox } from '../../../cdl/Checkbox/Checkbox';
import { Box } from '../../../common/ui/Box';
import type { DemandCalculation } from '../../types/DemandCalculation';
import type { DemandProductKey } from '../../types/DemandProductKey';
import { DemandHistoricalVolume } from '../DemandHistoricalVolume';

interface ProductKeyRowProps {
    product: DemandCalculation['productKeyVolumes'][number];
    isSelected: boolean;
    onChange: (productKey: DemandProductKey, checked: boolean) => void;
    showHistoricalData: boolean;
}

export const ProductKeyRow = ({ product, isSelected, onChange, showHistoricalData }: ProductKeyRowProps) => (
    <Box
        display="grid"
        gridTemplateColumns={showHistoricalData ? 'minmax(0, 1fr) 140px 24px' : 'minmax(0, 1fr) 24px'}
        columnGap={8}
        alignItems="center"
        paddingLeft={26}
        paddingY={6}
    >
        <Checkbox
            checked={isSelected}
            label={product.name}
            truncateLabel
            onChange={(event) => onChange(product.productKey, event.target.checked)}
        />
        {showHistoricalData ? (
            <DemandHistoricalVolume historicalVolume={product.historicalVolume} isLoading={false} />
        ) : null}
        <Box />
    </Box>
);
